import { defineStore } from 'pinia'
import { ref } from 'vue'
import { fetchAppConfigurationsApi } from '~/composables/useAppConfigurations'

export interface AppConfigurations {
  ordergrooveEnabled: boolean
}

export const useAppConfigurationStore = defineStore('appConfigurationStore', () => {
  const appConfigurations = ref<AppConfigurations | null>(null)
  const inFlightRequest = ref<Promise<AppConfigurations> | null>(null)

  function fetchAppConfigurations(forceRefresh = false) {
    if (!forceRefresh && appConfigurations.value) {
      return Promise.resolve(appConfigurations.value)
    }

    if (!forceRefresh && inFlightRequest.value) {
      return inFlightRequest.value
    }

    inFlightRequest.value = (async () => {
      try {
        const response = await fetchAppConfigurationsApi() as AppConfigurations
        appConfigurations.value = response
        return response
      } finally {
        inFlightRequest.value = null
      }
    })()

    return inFlightRequest.value
  }

  return { fetchAppConfigurations }
})